import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__modal-card -is-complete" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-7" }, "転職希望アンケートを保存しました。", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area" }, null, -1)

import { RouterLink } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendModal',
  props: {
    showModal: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': __props.showModal }]),
    id: "send-complete"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(RouterLink), {
        class: "p-recommend-form__modal-help-close",
        to: "/recommend/"
      }),
      _hoisted_2,
      _createVNode(_unref(RouterLink), {
        class: "p-recommend-form__modal-help-close-2",
        to: "/recommend/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("閉じる")
        ]),
        _: 1
      })
    ]),
    _hoisted_3
  ], 2))
}
}

})